import Vue from 'vue'
import App from './App.vue'
import 'whatwg-fetch'
// import * as Sentry from '@sentry/vue';
// import { BrowserTracing } from '@sentry/tracing';

import VueI18n from 'vue-i18n'
import pl from './trans/pl.json'
import es from './trans/es.json'
import en from './trans/en.json'
import fr from './trans/fr.json'

// if (process.env.NODE_ENV === 'production') {
//     Sentry.init({
//         Vue,
//         dsn: 'https://a018651a3bc6489da783ead05cdb9913@o522645.ingest.sentry.io/4504876004147200',
//         integrations: [new BrowserTracing()],
//         tracesSampleRate: 0.1,
//     })
// }

Vue.use(VueI18n)

const i18n = new VueI18n({
    messages: {
        en, pl, fr, es,
    },
    locale: Intl.DateTimeFormat().resolvedOptions().locale.slice(0, 2) || navigator.language.slice(0,2)
})

Vue.config.productionTip = false

new Vue({
    i18n,
    render: h => h(App),
}).$mount('#app')
